import React, { Component, PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import cookie from 'react-cookies'
import { withCookies, Cookies } from 'react-cookie'
import { connect } from 'react-redux'
import { instanceOf } from 'prop-types'
import slugify from 'slugify'
import { compose, bindActionCreators } from 'redux'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import apiURL from '../../Api/ApiUrl'
import { isMobile } from 'react-device-detect'
import { getOffset } from '../../utils/timeOffset'

import platform from 'platform'
import {
  getUserData,
  getUserFeed,
  getTrainingDays,
  reportUsersMessage,
  getUserChatName,
  editUserChatName,
  getUserStripeBoughtPackages,
  getFolders,
} from '../../Api/backendApi'
import { obtainAllNews, obtainFolderVideos } from '../../Api/base'
import { getAllUserWatchedVideos } from '../../Api/videoApi'
import * as folderActions from '../../actions/folderActions'
import * as newsActions from '../../actions/newsActions'
import MainScreen from './MainScreen.jsx'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { notify } from 'react-notify-toast'
import { trackPromise } from 'react-promise-tracker'
import { checkUserSubscriptionStatus } from '../../Api/backendApi'
import AppContext from '../../context/appContext'

import Mainscreen from './Red_Mainscreen.tsx'

// import {AppContext} from '../../App'
class MainScreenContainer extends Component {
  static contextType = AppContext

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }
  // static appContext = AppContext

  constructor(props) {
    super(props)
    const { cookies } = props

    // if (
    //   !window.matchMedia('(display-mode: standalone)').matches &&
    //   !isMobile &&
    //   (platform.name.includes('Chrome') || platform.name.includes('Edge')) &&
    //   (platform.os.family == 'Windows' ||
    //     platform.os.family != 'Android' ||
    //     (platform.name.includes('Chrome') && platform.os.family == 'OS X'))
    // ) {
    //   ;(function () {
    //     if (window.localStorage) {
    //       if (!localStorage.getItem('firstLoad')) {
    //         localStorage['firstLoad'] = true
    //         window.location.reload()
    //       } else localStorage.removeItem('firstLoad')
    //     }
    //   })()
    // }

    this.state = {
      user: null,
      isUserLoggedIn: cookie.load('accessToken') || false,
      openMenu: false,
      actualPage: 'news',
      pickedFolder: 'news',
      isPlayerActive: false,
      isUserDeclinedAppInstall: cookie.load('userDeclinedAppInstall') == 'true',
      folders: [],
      news: [],
      isLoading: false,
      unlockedMiazgasIds: [],
      folderEnterDates: cookie.load('userEnteredFolderDates') || false,
      userMail: cookie.load('userEmail'),
      isUserNewsletterSub: false,
      chatMessageToSend: '',
      isChatNameSet: false,
      userChatName: '',
      isReportSuccess: false,
      isReportConfirmationModalOpen: false,
      isThisPwa: false,
      appReadyToInstall: false,
      isDemoAccount: cookie.load('userDemoMode'),
      paidFolder: {},
      chatModalIsOpen: false,
      pwaReadyToDraw: false,
      installPromptEvent: null,
      sendingMessage: false,
      isListenerSet: false,
      loadingMessages: false,
      entryLoadMessage: false,
      loadedMessages: 25,
      shouldScrollMessages: true,
    }
  }

  removeConferenceCookie = () => {
    cookie.remove('userPushedToVideo')
  }

  getPaidContent = async () => {
    let userBoughtPackages = await getUserStripeBoughtPackages()

    this.setState({
      userBoughtPackages: userBoughtPackages,
    })

    this.context.updateAppState('userBoughtPackages', userBoughtPackages)
  }

  userHasPaidContent = (i) => {
    let hasPaidContent = false

    this.state.userBoughtPackages &&
      this.state.userBoughtPackages.forEach((item) => {
        if (item.product_name == 'Szpagat Turecki') {
          hasPaidContent = true
          return hasPaidContent
        }
      })

    return hasPaidContent
  }

  removeDemoCookie = () => {
    cookie.remove('userDemoMode')
  }

  getUserSubscriptionStatus = async () => {
    let subStatus

    if (this.context && !this.context.appState.subStatus) {
      subStatus = await checkUserSubscriptionStatus()
      this.context.updateAppState('subStatus', subStatus)
    } else {
      subStatus = this.context.appState.subStatus
    }

    this.setState({
      subStatus: subStatus.subscription,
    })
  }

  reloadOnce = () => {
    const shouldRefresh = cookie.load('shouldRefresh')

    if (shouldRefresh) {
      window.location.reload()
    }

    cookie.remove('shouldRefresh')
  }

  listAllEventListeners() {
    const allElements = Array.prototype.slice.call(
      document.querySelectorAll('*')
    )
    allElements.push(document)
    allElements.push(window)

    const types = []

    for (let ev in window) {
      if (/^on/.test(ev)) types[types.length] = ev
    }

    let elements = []
    for (let i = 0; i < allElements.length; i++) {
      const currentElement = allElements[i]
      for (let j = 0; j < types.length; j++) {
        if (typeof currentElement[types[j]] === 'function') {
          elements.push({
            node: currentElement,
            type: types[j],
            func: currentElement[types[j]].toString(),
          })
        }
      }
    }

    return elements.sort(function (a, b) {
      return a.type.localeCompare(b.type)
    })
  }

  checkIfInstalledPwa = (e) => {
    e.preventDefault()

    this.setState({
      installPromptEvent: e,
    })

    if (e) {
      this.setState({
        appReadyToInstall: true,
      })
    }
  }

  setUserData = async () => {
    let userData
    let userChatName

    if (!this.context.appState.user) {
      userData = await trackPromise(getUserData())
      userChatName = await trackPromise(getUserChatName())
      this.setState({
        user: userData,
        isUserNewsletterSub: userData.is_newsletter_subscriber,
        userChatName: userChatName,
      })

      this.context.updateAppState('user', {
        user: userData,
        isUserNewsletterSub: userData.is_newsletter_subscriber,
        userChatName: userChatName,
      })
    } else {
      this.setState({
        user: this.context.appState.user.user,
        isUserNewsletterSub: this.context.appState.user.isUserNewsletterSub,
        userChatName: this.context.appState.user.userChatName,
      })
    }
  }

  checkUserDemoAccount = () => {
    if (this.state.user.has_subscription == false) {
      this.setState({
        isDemoAccount: true,
      })
    }
  }

  getPaidFolder = () => {
    const folders = this.context.appState.folders || this.state.folders
    let paidFolder
    folders.forEach((folder) => {
      folder.seo_keywords.forEach((seoKeyword) => {
        if (seoKeyword.text == 'PAID_CONTENT') {
          paidFolder = folder
          return
        }
      })
    })

    this.setState({
      paidFolder: paidFolder,
    })
  }

  // CHAT FUNCTIONS

  chatScrollListener = async () => {
    // Gather additional messages when user scroll top of the chat window
    const chatElement = document.getElementById('scroll-container')

    chatElement.addEventListener('scroll', async () => {
      if (chatElement.scrollTop == 0) {
        await this.getMarker(this.state.loadedMessages + 25, true)

        this.setState({
          loadedMessages: this.state.loadedMessages + 25,
        })
        await setTimeout(() => {
          const singleMessageElements = document.querySelectorAll(
            '.messages__single-message'
          )

          if (this.state.shouldScrollMessages) {
            chatElement.scrollTop =
              chatElement.scrollHeight / (this.state.loadedMessages / 25) + 1
          }
          this.setState({
            shouldScrollMessages: true,
          })
        }, 150)
      }
    })
  }

  handleChatJoinButton = (e) => {
    if (this.state.userChatName != '') {
      this.setState({
        isChatNameSet: true,
      })
      editUserChatName(this.state.userChatName)
    } else {
      notify.show(`Musisz wpisać imię`, 'error', 2000)
    }
  }

  handleCloseReportScreen = () => {
    this.setState({
      isReportSuccess: false,
    })
  }
  editUserChatName = (e) => {
    this.setState({
      userChatName: e.target.value,
    })
  }

  ScrollDownMessager = () => {
    var objDiv = document.getElementById('scroll-container')

    if (document.body.contains(objDiv)) {
      objDiv.scrollTop = objDiv.scrollHeight
    }
  }

  listenForFirebaseChange = () => {
    // test chat 98C6C14ACCE440C6AB3058D2970D5A0F
    // prod chat 0e23f94f1435d2e63d39865c407d847f

    firebase
      .firestore()
      .collection('0e23f94f1435d2e63d39865c407d847f')
      .orderBy('timestamp', 'desc')
      .limit(this.state.loadedMessages + 25)
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data())

        const sorted = _.sortBy(data, 'timestamp.seconds')
        if (
          data &&
          data[0].timestamp &&
          this.state.chatMessages[0].timestamp.seconds <
            data[24].timestamp.seconds
        )
          this.setState({
            chatMessages: sorted,
          })
      })

    this.setState({
      isListenerSet: true,
    })
  }

  async getMarker(messagesAmount, isLoadHistory) {
    // test chat 98C6C14ACCE440C6AB3058D2970D5A0F
    // prod chat 0e23f94f1435d2e63d39865c407d847f

    this.setState({
      loadingMessages: true,
    })
    const snapshot = await firebase
      .firestore()
      .collection('0e23f94f1435d2e63d39865c407d847f')
      .orderBy('timestamp', 'desc')
      .limit(messagesAmount)
      .get()

    const data = snapshot.docs.map((doc) => doc.data())
    const sorted = _.sortBy(data, 'timestamp.seconds')

    if (isLoadHistory && _.isEqual(this.state.chatMessages, sorted)) {
      this.setState({
        shouldScrollMessages: false,
        loadingMessages: false,
      })
    } else {
      this.setState({
        chatMessages: sorted,
        loadingMessages: false,
      })
    }
  }

  addmessageOnEnter = (e) => {
    if (e.key === 'Enter') {
      this.addNewMessageToFirebaseChat()
    } else {
      return
    }
  }

  addNewMessageToFirebaseChat = async () => {
    if (
      !this.state.chatMessageToSend.replace(/\s/g, '').length ||
      this.state.chatMessageToSend == ''
    ) {
      alert('Wiadomość nie może być pusta')
      return
    }

    this.setState({
      sendingMessage: true,
      chatMessageToSend: '',
    })

    // test chat 98C6C14ACCE440C6AB3058D2970D5A0F
    // prod chat 0e23f94f1435d2e63d39865c407d847f

    const res = await firebase
      .firestore()
      .collection('0e23f94f1435d2e63d39865c407d847f')
      .add({
        author_id: this.state.user.id,
        author_name: this.state.userChatName,
        message: this.state.chatMessageToSend,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      })

    if (res) {
      var objDiv = document.getElementById('scroll-container')

      if (document.body.contains(objDiv)) {
        objDiv.scrollTop = objDiv.scrollHeight
        this.setState({
          sendingMessage: false,
        })
      }
    }
  }

  setMessage = (e) => {
    this.setState({
      chatMessageToSend: e.target.value,
    })
  }

  closeReportConfirmationModal = () => {
    this.setState({
      isReportConfirmationModalOpen: false,
    })
  }

  handleMobileReportMessage = async () => {
    const isReportSuccess = await reportUsersMessage(
      this.state.attemptedToReportmessage.author_id,
      this.state.attemptedToReportmessage.message
    )

    if (isReportSuccess) {
      this.setState({
        isReportSuccess: true,
      })
    }
    this.setState({
      isReportConfirmationModalOpen: false,
    })
  }

  reportMessage = async (message) => {
    if (isMobile) {
      this.setState({
        isReportConfirmationModalOpen:
          this.state.user.is_banned_on_chat == false ? true : false,
        attemptedToReportmessage: message,
      })
    } else {
      const isReportSuccess = await reportUsersMessage(
        message.author_id,
        message.message
      )

      if (isReportSuccess) {
        this.setState({
          isReportSuccess: true,
        })
      }
    }
  }

  // END CHAT FUNCTIONS

  //1 -  CHECK IF FOLDER HAS NEV VIDEO VARIABLE IN SEO KEYWORDS AND THEN IF TRUE THEN EDIT CURRENT LOCAL STORE WITH THOSE DATA
  updateFolderByNewVideoInformation = () => {
    const { folders } = this.state
    let newVideoDate

    folders.forEach((folder, i) => {
      folder.seo_keywords.forEach((keyword) => {
        if (keyword.text.includes('NEW_VIDEO')) {
          newVideoDate = keyword.text.split('_')[3]
          let parsedVideoDate = moment(
            `${newVideoDate[0]}${newVideoDate[1]}-${newVideoDate[2]}${newVideoDate[3]}-${newVideoDate[4]}${newVideoDate[5]}${newVideoDate[6]}${newVideoDate[7]}`,
            'DD-MM-YYYY'
          ).format('DD-MM-YYYY')
          this.setState((prevState) => {
            const newItems = [...prevState.folders]
            newItems[i].newVideo = keyword
            newItems[i].newVideoDate = parsedVideoDate
            return { folders: newItems }
          })
        }
      })
    })
  }

  updateUserSubLocalChange = () => {
    this.setState({
      isUserNewsletterSub: !this.state.isUserNewsletterSub,
    })
  }

  //3 - SET DATA FROM COOKIES  TO CORRECT FOLDER
  obtainFolderEnterDatesFromCookie = () => {
    const { folders, folderEnterDates } = this.state

    if (folderEnterDates) {
      folders.forEach((folder, i) => {
        folderEnterDates.forEach((folderDate) => {
          if (folderDate.folderOrder == folder.Folderorder) {
            this.setState((prevState) => {
              const newItems = [...prevState.folders]
              newItems[i].lastEnter = folderDate.date
              return { folders: newItems }
            })
          }
        })
      })
    }
  }

  //4 - FUNCTION WHICH TAKES ALL PREVIOUS INFO AND DETERMINS IF BADGE SHOULD BE SHOWN
  showNewVideoBadge = (newVideoDate, lastEnter) => {
    // test var let newVideoDate = '09-09-2020'
    // test var let lastEnter = '08-09-2020'

    let shouldShowBadge = false
    const today = new Date()
    const isNewVideoThreeDaysOld = moment(today, 'DD-MM-YYYY')
      .subtract(3, 'days')
      .isAfter(moment(newVideoDate, 'DD-MM-YYYY'))

    if (newVideoDate != undefined) {
      if (lastEnter != undefined) {
        const isNewVideoBeforeLastEnter = moment(
          newVideoDate,
          'DD-MM-YYYY'
        ).isBefore(lastEnter, 'DD-MM-YYYY')
        if (!isNewVideoThreeDaysOld) {
          if (!isNewVideoBeforeLastEnter) {
            shouldShowBadge = true
            return shouldShowBadge
          }
        }
      } else {
        if (!isNewVideoThreeDaysOld) {
          shouldShowBadge = true
          return shouldShowBadge
        }
      }
    }

    return shouldShowBadge
  }

  //2 - ON FOLDER CLICK - STORE IN COOKIES LAST ENTER DATE ON THIS FOLDER

  storeUserEnteredFolderTime = (order) => {
    const { cookies } = this.props
    const date = new Date()

    let currentCookieDates = cookie.load('userEnteredFolderDates')

    // (1)
    if (currentCookieDates && currentCookieDates.length > 0) {
      const i = currentCookieDates.findIndex(
        (_item) => _item.folderOrder === order
      )
      if (i > -1) currentCookieDates[i] = { folderOrder: order, date: date }
      else currentCookieDates.push({ folderOrder: order, date: date })
      cookie.save('userEnteredFolderDates', currentCookieDates, { path: '/' })
    }
    // (2)
    else
      cookie.save(
        'userEnteredFolderDates',
        [{ folderOrder: order, date: date }],
        { path: '/' }
      )

    this.setState((prevState) => {
      const newItems = [...prevState.folders]
      newItems[order].lastTimeEntered = date
      return { folders: newItems }
    })
  }

  closePwaButton = (e) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    cookie.save('userDeclinedAppInstall', true)
    this.setState({
      isUserDeclinedAppInstall: true,
    })
  }

  handlePwaAddBtn = (installPromptEvent) => {
    const isUserDeclinedAlreadyA2Hs = cookie.load('userDeclinedAppInstall')

    const addBtn = document.querySelector('.add-button')
    if (addBtn && this.state.appReadyToInstall) {
      addBtn.addEventListener('click', (e) => {
        setTimeout(() => {
          installPromptEvent.prompt()
          installPromptEvent.userChoice.then((choice) => {
            if (choice.outcome === 'accepted') {
              this.setState({
                isUserDeclinedAppInstall: true,
              })
              window.location.reload(false)
            } else {
              window.location.reload(false)
            }
          })
        }, 100)
      })
    }
    this.setState({
      pwaReadyToDraw: true,
    })
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  obtainAllFolders = async () => {
    let allFolders

    const obtainAllFolders = {
      method: 'GET',
      url: `${apiURL}/api/vimeovideos/albums/`,
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
    }
    await axios(obtainAllFolders)
      .then((response) => {
        allFolders = response

        this.sortFolders(response.data.data)
      })
      .catch(({ response, error }) => {
        console.log(error)
      })

    return allFolders
  }

  updateFolderState = (newFolders) => {
    if (newFolders) {
      this.sortFolders(newFolders)
    } else {
      this.setState({
        folders: this.props.folders,
      })
    }
  }

  sortFolders = (folders) => {
    let unchangedFolders = folders
    let unsorted = folders
    let onlyNumber

    if (unsorted !== undefined) {
      unsorted.forEach((folder) => {
        folder.seo_keywords.map((keyword) => {
          if (keyword.text.includes('DASHBOARD_ORDER')) {
            unchangedFolders.map((stateFolder) => {
              if (stateFolder.uri === folder.uri) {
                onlyNumber = keyword.text.replace(/DASHBOARD_ORDER_/g, '')
                folder.Folderorder = parseInt(onlyNumber)
              }
            })
          }
        })
      })
    }

    var sortedObjs = _.sortBy(unsorted, 'Folderorder')

    this.setState({
      folders: sortedObjs,
    })

    this.context.updateAppState('folders', sortedObjs)
  }

  checkFoldersDisabled = (folder, i) => {
    let isEnabled

    if (!this.state.isDemoAccount) {
      if (folder && folder.hasOwnProperty('seo_keywords')) {
        folder.seo_keywords.forEach((keywords) => {
          if (keywords.text === 'ENABLED_TRUE') {
            isEnabled = true
          }
        })
        folder.seo_keywords.forEach((keywords) => {
          if (keywords.text === 'ENABLED_FALSE') {
            this.state.unlockedMiazgasIds.includes(folder.Folderorder)
              ? (isEnabled = true)
              : (isEnabled = false)
          }
        })
      }
    }

    if (this.state.paidFolder && this.state.paidFolder.Folderorder == i) {
      isEnabled = this.userHasPaidContent()
    }

    return isEnabled
  }

  checkFolderShouldBeDisabled = async () => {
    let userWatchedVids
    if (this.context && !this.context.appState.allUserStatuses) {
      userWatchedVids = await getAllUserWatchedVideos()

      this.context.updateAppState('allUserStatuses', userWatchedVids)
    } else {
      userWatchedVids = this.context.appState.allUserStatuses
    }

    let lockedFolderId
    let lockedFolderVideosCount
    let prevWatchedVidsArr = []
    let prevWatchedWithoutIntro = []
    let isDisabled = true

    const stateFolders = this.context.appState.folders || this.state.folders
    // first loop over all folders and find which one is disabled by default and how many vids
    stateFolders.forEach((folder, i) => {
      let folderLength
      if (folder && folder.hasOwnProperty('seo_keywords')) {
        folder.seo_keywords.forEach((keywords) => {
          if (keywords.text === 'ENABLED_FALSE') {
            folder.seo_keywords.forEach((keywords) => {
              if (keywords.text.includes('VIDEO_COUNT')) {
                folderLength = keywords.text.split('_')
              }
            })

            lockedFolderId = folder && folder.Folderorder

            // In order to unlock locked folder we have to check if LOCKED FOLDER'S PREV FOLDER has been watched by user in whole. So we check in there is 21 videos with locked order id - 1 (prev than founded first disabled and go on)
            prevWatchedWithoutIntro = _.filter(
              userWatchedVids,
              (vid) =>
                vid.is_watched == true &&
                vid.album.album_id == lockedFolderId - 1 &&
                !vid.is_intro
            )
            prevWatchedVidsArr = _.filter(
              userWatchedVids,
              (vid) =>
                vid.is_watched == true &&
                vid.album.album_id == lockedFolderId - 1
            )

            if (
              (prevWatchedVidsArr &&
                prevWatchedVidsArr.length == folderLength[2]) ||
              prevWatchedWithoutIntro.length == parseInt(folderLength[2] - 1)
            ) {
              this.setState({
                unlockedMiazgasIds: [
                  ...this.state.unlockedMiazgasIds,
                  lockedFolderId,
                ],
              })
              // setUserUnlockedMiazgas()
              isDisabled = false
              return isDisabled
            }
          }
        })
      }
    })
    return isDisabled
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  obtainNews = async () => {
    let allNews

    const obtainAllNews = {
      method: 'GET',
      url: `${apiURL}/api/vimeovideos/albums/6548644/video/`,
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
    }
    await axios(obtainAllNews)
      .then((response) => {
        allNews = _.orderBy(
          response.data.data,
          moment(response.data.data.created_time).format('YYYY-MM-DD')
        )

        this.setState({
          news: allNews,
        })
      })
      .catch(({ response, error }) => {
        console.log(error)
      })

    this.context.updateAppState('news', allNews)

    return allNews
  }

  onOpenMenuClick = () => {
    this.setState({
      openMenu: !this.state.openMenu,
    })
  }

  closeMenu = () => {
    this.setState({
      openMenu: false,
    })
  }

  changeLocation = (
    location,
    additionalInfo,
    albumId,
    folderName,
    keywords
  ) => {
    this.props.history.push({
      pathname: `${location}`,
      state: {
        path: additionalInfo,
        albumId: albumId,
        folderName: folderName,
        keywords,
      },
    })
  }

  onSubpageChange = (page) => {
    this.setState({
      actualPage: page,
    })
  }

  generateApiPath = (folderName) => {
    let apiPath

    const folders = this.context.appState.folders || this.state.folders

    folders.forEach((folder) => {
      if (folder.name == folderName) {
        apiPath = folder.metadata.connections.videos.uri
      }
    })

    return apiPath
  }

  pickFolder = (folderName, isFolderEnabled, albumId, keywords, i) => {
    const path = this.generateApiPath(folderName)

    this.storeUserEnteredFolderTime(i)

    isFolderEnabled &&
      this.changeLocation(
        `/foldery/${folderName}`,
        path,
        albumId,
        folderName,
        keywords
      )
  }

  openVideo = (videoPath, name, videoId) => {
    this.props.history.push({
      pathname: `/video/${slugify(name)}`,
      state: {
        path: videoPath,
        newsVideo: true,
      },
    })
  }

  logout = () => {
    const { cookies } = this.props
    cookie.remove('accessToken', { path: '/' })
    cookie.remove('refreshToken', { path: '/' })
    this.props.history.push('/')
  }

  splitFolderName = (name) => {
    let splittedName
    if (name.includes(';')) {
      splittedName = name.split(';')
    }
    return splittedName
  }

  openChatModal = () => {
    this.setState({
      chatModalIsOpen: true,
    })

    setTimeout(() => {
      var objDiv = document.getElementById('scroll-container')

      if (document.body.contains(objDiv)) {
        objDiv.scrollTop = objDiv.scrollHeight
      }
    }, 100)
  }
  closeChatModal = () => {
    this.setState({
      chatModalIsOpen: false,
    })
  }

  setVideosWatched = () => {
    const date = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

    const isThisPaidContent = cookie.load('isPaidContent')
    const videoId = cookie.load('videoId')

    if (!window.navigator.onLine) {
      alert(
        'Brak połączenia z internetem. Nie można zapisać treningu. Spróbuj ponownie gdy połączenie z internetem zostanie przywrócone.'
      )

      return
    }

    const url =
      isThisPaidContent == true ? 'videostatuschallange' : 'videostatus'
    const offset = getOffset()
    const setWatchedVideoStatusConfig = {
      method: 'patch',
      url: `${apiURL}/api/${url}/${videoId}/set_as_watched/?offset_ms=${offset}`,
      body: { locked_datetime: date },
      headers: {
        Authorization: `Bearer ${cookie.load('accessToken')}`,
      },
    }

    axios(setWatchedVideoStatusConfig)
      .then((reponse) => {
        notify.show(
          'Status został poprawnie dodany, ukończony trening został zapisany w bazie.',
          'success',
          5000
        )
        cookie.remove('isPaidContent')
        cookie.remove('videoId')
        cookie.remove('sendAgainSetWatchedRequest')
      })
      .catch((error, response) => {
        if (error.status === 401 && this.state.isWatchRefreshed == false) {
          axios
            .post(`${apiURL}/api/auth/token/refresh/`, {
              refresh: cookie.load('refreshToken'),
            })
            .then(async (response) => {
              if (response.status === 200 || response.status === 201) {
                cookie.remove('accessToken')
                cookie.save('accessToken', response.data.access)

                this.setWatchedLocalStatus()

                this.setState({
                  isWatchRefreshed: true,
                  newWatchToken: response.data.access,
                  videoRequestDone: true,
                })

                setTimeout(() => {
                  this.setVideosWatched()
                }, 150)
              }
              notify.show(
                'Status został poprawnie dodany, ukończony trening został zapisany w bazie.',
                'success',
                5000
              )
              cookie.remove('isPaidContent')
              cookie.remove('videoId')
              cookie.remove('sendAgainSetWatchedRequest')
            })
        }
      })
  }

  render() {
    return (
      // <MainScreen
      //   user={this.state.user}
      //   openMenu={this.state.openMenu}
      //   onOpenMenuClick={this.onOpenMenuClick}
      //   closeMenu={this.closeMenu}
      //   changeLocation={this.changeLocation}
      //   actualPage={this.state.actualPage}
      //   onSubpageChange={this.onSubpageChange}
      //   pickFolder={this.pickFolder}
      //   pickedFolder={this.state.pickedFolder}
      //   isPlayerActive={this.state.isPlayerActive}
      //   openVideo={this.openVideo}
      //   activeVideoURL={this.state.activeVideoURL}
      //   isLoading={this.state.isLoading}
      //   folders={this.context.appState.folders || this.state.folders}
      //   news={this.context.appState.news || this.state.news}
      //   selectedFoldersVideos={this.state.selectedFoldersVideos}
      //   video={this.state.video}
      //   checkFoldersDisabled={this.checkFoldersDisabled}
      //   logout={this.logout}
      //   isUserDeclinedAppInstall={this.state.isUserDeclinedAppInstall}
      //   closePwaButton={this.closePwaButton}
      //   splitFolderName={this.splitFolderName}
      //   showNewVideoBadge={this.showNewVideoBadge}
      //   userMail={this.state.userMail}
      //   activeSubscriptionEndTime={this.state.activeSubscriptionEndTime}
      //   updateUserSubLocalChange={this.updateUserSubLocalChange}
      //   isUserNewsletterSub={this.state.isUserNewsletterSub}
      //   addMessage={this.addNewMessageToFirebaseChat}
      //   chatMessages={this.state.chatMessages}
      //   setMessage={this.setMessage}
      //   chatMessageToSend={this.state.chatMessageToSend}
      //   reportMessage={this.reportMessage}
      //   editUserChatName={this.editUserChatName}
      //   userChatName={this.state.userChatName}
      //   isChatNameSet={this.state.isChatNameSet}
      //   handleChatJoinButton={this.handleChatJoinButton}
      //   addmessageOnEnter={this.addmessageOnEnter}
      //   isReportSuccess={this.state.isReportSuccess}
      //   handleCloseReportScreen={this.handleCloseReportScreen}
      //   closeReportConfirmationModal={this.closeReportConfirmationModal}
      //   isReportConfirmationModalOpen={this.state.isReportConfirmationModalOpen}
      //   handleMobileReportMessage={this.handleMobileReportMessage}
      //   isDemoAccount={this.state.isDemoAccount}
      //   isThisPwa={this.state.isThisPwa}
      //   appReadyToInstall={this.state.appReadyToInstall}
      //   closeChatModal={this.closeChatModal}
      //   openChatModal={this.openChatModal}
      //   chatModalIsOpen={this.state.chatModalIsOpen}
      //   pwaReadyToDraw={this.state.pwaReadyToDraw}
      //   paidFolder={this.state.paidFolder}
      //   subStatus={this.state.subStatus}
      //   userHasPaidContent={this.userHasPaidContent}
      //   sendingMessage={this.state.sendingMessage}
      //   loadingMessages={this.state.loadingMessages}
      // />

      <Mainscreen />
    )
  }
}

// function mapStateToProps(state) {
//   return {
//     user: state.user,
//     folders: state.folders.folders,
//     news: state.news.news,
//     isLoading:
//       state.news.isLoading || state.folders.isLoading || state.isLoading,
//   }
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     folderActions: bindActionCreators(folderActions, dispatch),
//     newsActions: bindActionCreators(newsActions, dispatch),
//   }
// }

// export default compose(
//   withRouter,
//   withCookies,
//   connect(mapStateToProps, null)
// )(MainScreenContainer)

export default MainScreenContainer
